import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const documentTypeFeatureKey = 'documentType';

export interface DocumentTypeState {
  loadDocumentType: any;
  loadDocumentTypeSuccess: any;
  loadDocumentTypeFailure: Error | any;
}

export const initialState: DocumentTypeState = {
  loadDocumentType: undefined,
  loadDocumentTypeSuccess: undefined,
  loadDocumentTypeFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadDocumentTypesSuccess, (state, action) => ({
    ...state,
    loadDocumentTypeSuccess: action.response
  })),
  on(actions.loadDocumentTypesFailure, (state, action) => ({
    ...state,
    loadDocumentTypeFailure: action.error
  }))
);

export const getDocumentType = (state: DocumentTypeState) => state.loadDocumentTypeSuccess;
